module.exports = __webpack_public_path__ + "static/7-baa946daec5b29369b31e809629f495b.gif";